import type { LandingDict } from './en';

const th: LandingDict = {
  nav: { chat: 'Chat Apps', agentic: 'Agentic Apps', build: "สร้างแอป", org: "My Org", pricing: 'ราคา', privacy: "ความเป็นส่วนตัว", contact: "ติดต่อเรา", language: 'ภาษา' },
  hero: {
    titlePre: 'ขุมพลัง ',
    titleMark: 'AI ในเครื่อง',
    titlePost: '\nของคุณ',
    sub: "เปลี่ยนความรู้เชี่ยวชาญ สเปรดชีต และการประชุม ให้เป็นคำตอบ กราฟ และสไลด์ ไม่มีข้อมูลใดออกจาก Mac ของคุณ",
    watch: "ดูวิดีโอ 2 นาที",
    pill: "เวอร์ชันล่าสุด",
    chip: "ปิด Wi‑Fi · ส่งออก 0 ไบต์",
    badges: { offline: "ใช้งานออฟไลน์ได้", server: "เซิร์ฟเวอร์ของคุณ ไม่ใช่ของเรา", free: "เริ่มใช้ฟรี" },
    reqs: 'ต้องใช้ Mac ที่มี Apple Silicon · หน่วยความจำขั้นต่ำ 16GB · 32GB ขึ้นไปใช้โมเดลแนะนำที่ใหญ่กว่าได้',
  },
  stats: {
    free: 'ฟรี',
    freeSub: 'Chat Apps ทั้งหมด การดาวน์โหลดโมเดล และการอัปเดต — ฟรีเสมอ',
    chatApps: 'Chat Apps',
    agenticApps: 'Agentic Apps',
    bytesSub: 'ไบต์ที่ส่งขึ้นคลาวด์ เมื่อรัน AI บน Mac เครื่องนี้',
    langsSub: 'ภาษาบนอินเทอร์เฟซ ตั้งแต่ไทย English ไปจนถึง 日本語',
  },
  film: { kicker: 'วิดีโอ', title: 'ดู Estha ทำงานจริง', watchOnYouTube: 'ดูบน YouTube', trouble: 'เล่นไม่ได้ใช่ไหม ดูบน YouTube ↗' },
  overview: {
    kicker: 'แอปเดียว ทำงานได้สี่แบบ',
    title: 'จากแชต สู่เอเจนต์\nสู่แอปที่ใช้กันทั้งทีม',
    explore: 'สำรวจ',
    chat: { title: 'Chat Apps', desc: 'ผู้เชี่ยวชาญ AI ที่ตอบจากฐานความรู้ที่คัดสรรมา ทั้งตำรา คู่มือ และความรู้เฉพาะทาง', tag: 'ฟรีเสมอ' },
    agentic: { title: 'Agentic Apps', desc: 'เอเจนต์ AI ที่จัดการงานซับซ้อนได้ตั้งแต่ต้นจนจบ', tag: '{n} แอป และจะมีเพิ่มอีก' },
    build: { title: "สร้างแอป", desc: 'เปลี่ยนเอกสารของคุณเป็น Chat App ด้วย Quick Bot หรือออกแบบโฟลว์บนแคนวาสของ Playground', tag: 'Quick Bot · Playground' },
    org: { title: 'My Org', desc: 'พื้นที่แอปในแบรนด์ขององค์กรคุณ แอปผ่านการตรวจสอบ และควบคุมสิทธิ์เข้าถึงได้', tag: 'องค์กร' },
  },
  chat: {
    kicker: 'Chat Apps',
    title: 'AI ผู้เชี่ยวชาญ\nที่ตอบจากความรู้จริง',
    freePill: 'ฟรีเสมอ',
    lede: 'Chat App ทุกตัวมาพร้อมฐานความรู้ของตัวเอง ทำดัชนีบน Mac ของคุณโดยตรง',
    feats: {
      kb: { title: 'ฐานความรู้ในเครื่อง', desc: 'ติดตั้งแอปแล้วฐานความรู้จะถูกสร้างในเครื่อง คำตอบมาจากเนื้อหาที่คัดสรรมา' },
      files: { title: 'ใช้ไฟล์ของคุณเอง', desc: 'แนบรูปภาพ PDF DOCX TXT หรือ MD ได้ เอกสารยาวใช้การค้นคืนอัจฉริยะ' },
      browse: { title: 'เลือกดู ปักหมุด บันทึกรายการโปรด', desc: 'หมวดหมู่ตั้งแต่การประเมินไปจนถึงอาชีพ แท็ก NEW สำหรับแอปใหม่ และ ⌘K เพื่อค้นหาทุกอย่าง' },
    },
  },
  agentic: {
    kicker: 'Agentic Apps',
    title: 'Agentic Apps {n} แอป\nและจะมีอีกเรื่อย ๆ',
    lede: 'จากสเปรดชีต PDF ไฟล์เสียง หรือแค่ไอเดีย สู่แผนภูมิ สไลด์ เอกสาร หรือต้นแบบที่เสร็จสมบูรณ์ — อย่างเป็นส่วนตัวบน Mac ของคุณ',
    seeThem: 'ดูการทำงานจริง',
  },
  build: {
    kicker: 'สร้างแอป',
    title: 'สร้าง Chat App ของคุณเอง\nบน Mac ของคุณ',
    lede: 'เปลี่ยนไฟล์ของคุณเป็น Chat App ทำดัชนีในเครื่อง แล้วเผยแพร่เมื่อพร้อม',
    quick: {
      badge: 'แนะนำ',
      desc: 'อัปโหลดฐานความรู้และเขียนพรอมป์ตระบบ จากนั้นเผยแพร่ เหมาะสำหรับเปลี่ยนเอกสารให้เป็นบอทถาม-ตอบได้อย่างรวดเร็ว',
      items: ['แบบฟอร์มหน้าเดียว เสร็จในไม่กี่ขั้นตอน', 'ถาม-ตอบจากฐานความรู้ได้ทันที', 'เทมเพลตพรอมป์ในตัวเพื่อเป็นแรงบันดาลใจ'],
    },
    advanced: {
      title: 'ขั้นสูง · Playground',
      desc: 'ตัวแก้ไขโหนดแบบภาพ ช่วยประกอบหลายโหนด กิ่งก้าน AB test และการกำหนดเส้นทางด้วยคำสำคัญได้อย่างอิสระ',
      items: ['แคนวาสโหนด', 'หลายโหนด / กิ่งก้าน / AB test', 'ฟิลด์ละเอียดและการดีบัก'],
    },
    guideTitle: 'มีผู้ช่วยสร้างแอป AI ในเครื่องอยู่ข้าง ๆ',
    guideText: 'บอกว่าอยากให้แอปทำอะไร แล้วผู้ช่วยจะแนะนำทีละขั้นว่าต้องลากโหนดไหนและเชื่อมต่ออย่างไร การสร้างแอปรวมอยู่ในแผนพรีเมียม',
  },
  private: {
    kicker: 'เป็นส่วนตัวตั้งแต่การออกแบบ',
    title: "ไม่ส่งข้อมูลขึ้นคลาวด์\nไม่ติดตามงานของคุณ",
    lede: "คุณเลือกได้ว่า AI จะทำงานที่ไหน Estha เลือกโมเดลที่เหมาะกับแต่ละฟีเจอร์ให้โดยอัตโนมัติ และคุณเปลี่ยนโมเดลในแอปได้ทุกเมื่อ",
    boundary: "ขอบเขตข้อมูล = เครือข่ายของคุณ",
    local: { title: 'บน Mac เครื่องนี้', desc: 'ออฟไลน์ทั้งหมด ข้อมูลไม่ออกจากเครื่องนี้ ใช้หน่วยความจำของคอมพิวเตอร์เครื่องนี้รันโมเดล', best: 'เหมาะกับ Mac ที่มีหน่วยความจำเหลือเฟือ' },
    server: { title: 'บน Estha Server ของฉัน', desc: 'โอนงานหนักไปยัง Mac ที่แรงกว่าในเครือข่าย เพื่อให้ Mac เครื่องนี้เบาอยู่เสมอ', best: 'เหมาะกับแล็ปท็อปและ Mac ที่หน่วยความจำน้อย' },
    cluster: { desc: 'เชื่อมต่อกับ Mac Studio Cluster เพื่อถ่ายโอนการประมวลผลหนัก ขณะที่ข้อมูลของคุณยังคงอยู่ในองค์กร', best: 'ค้นหาโหนด Estha Studio Master บนเครือข่ายให้อัตโนมัติ' },
    models: {
      every: 'รันได้บน Mac ทุกรุ่นที่รองรับ',
      whisper: "Whisper สำหรับถอดเสียง",
      recommended: 'โมเดลแนะนำ',
      larger: "โมเดล Qwen และ Gemma ขนาดใหญ่ขึ้น",
      vision: "โมเดลวิชันสำหรับรูปภาพ",
      open: 'โมเดลโอเพนซอร์ส ปรับให้เหมาะกับ Apple Silicon',
      openItems: ['ดาวน์โหลดและสลับโมเดลได้ในแอป', 'โมเดลเฉพาะสำหรับเขียนโค้ดและ embedding', 'ดาวน์โหลดโมเดลฟรีเสมอ'],
    },
  },
  org: {
    kicker: 'My Org',
    title: 'พื้นที่แอป AI\nขององค์กรคุณเอง',
    lede: 'ส่วนเฉพาะในแบรนด์ของคุณภายใน Estha รวมแอปที่องค์กรตรวจสอบแล้วสำหรับบุคลากร',
    signIn: 'ลงชื่อเข้าใช้ My Org Admin',
    talk: 'คุยกับทีม Estha',
    feats: {
      review: { title: 'ตรวจสอบก่อนเผยแพร่', desc: 'ทุกแอปใหม่ การอัปเดต หรือการนำออก ต้องผ่านผู้ดูแลระบบ หากถูกปฏิเสธจะมีความเห็นเป็นลายลักษณ์อักษรเสมอ' },
      access: { title: 'กำหนดสิทธิ์รายกลุ่มหรือรายบุคคล', desc: 'กำหนดได้ชัดเจนว่าใครเห็นแอปไหน ตามแผนก ทีม หรือรายบุคคล' },
      brand: { title: 'แบรนด์ของคุณ ในแอป', desc: 'ชื่อองค์กร ข้อความต้อนรับ โลโก้ แบนเนอร์ และสีธีม — ดูตัวอย่างได้ก่อนเผยแพร่จริง' },
    },
  },
  pricing: {
    kicker: 'สมาชิก',
    title: 'เริ่มต้นฟรี\nปลดล็อกทุกอย่างเมื่อพร้อม',
    free: { name: 'ฟรี', sub: 'ฟรีเสมอ', items: ["Chat Apps ทั้งหมด", 'การประมวลผลเอกสาร ใช้ฟรีตลอดไป', 'การดาวน์โหลดโมเดล ซอฟต์แวร์ และการอัปเดต — ใช้ฟรีเสมอ'] },
    premium: {
      name: 'พรีเมียม', flag: 'ทดลองใช้ฟรี 14 วัน', firstYear: 'ปีแรก',
      sub: 'จากนั้น $30/ปี เริ่มทดลองใช้ฟรี 14 วันหลังยืนยันอีเมล',
      items: ['สิทธิ์ทั้งหมดของแผนฟรี', 'Agentic Apps ทั้งหมดในปัจจุบันและอนาคต', 'เครื่องมือสร้าง Chat App — สร้าง แก้ไข ดูตัวอย่าง บันทึก และเผยแพร่แชตบอตในเครื่อง'],
      cta: 'เริ่มทดลองใช้ในแอป',
    },
    enterprise: {
      name: 'องค์กร', price: 'ติดต่อเรา', sub: 'สำหรับองค์กรที่ต้องการใช้ Estha ทั้งทีม',
      items: ['สิทธิ์ทั้งหมดของแผนพรีเมียม', 'Chat Apps และ Agentic Apps ที่ปรับแต่งเฉพาะสำหรับทีมของคุณ', 'ความสามารถของแอป Estha Server', 'พื้นที่แอป My Org และMy Org Admin'],
    },
  },
  faq: {
    title: 'เรื่องน่ารู้\nก่อนดาวน์โหลด',
    spec: { chip: 'ชิป', memory: 'หน่วยความจำ', memMin: 'ขั้นต่ำ 16GB', memRec: '32GB ขึ้นไปสำหรับโมเดลแนะนำ', languages: 'ภาษา', langsVal: 'อินเทอร์เฟซ 13 ภาษา', version: 'เวอร์ชันล่าสุด' },
    qa: [
      { q: 'มีข้อมูลออกจาก Mac ของฉันไหม', a: 'เมื่อรัน AI บน Mac เครื่องนี้ ทุกอย่างทำงานแบบออฟไลน์ ไม่มีข้อมูลออกจากเครื่อง หากเลือก Estha Server หรือ Mac Studio Cluster งานจะถูกส่งไปยังเครื่องนั้นในเครือข่ายของคุณเท่านั้น' },
      { q: "อะไรบ้างที่ต้องต่ออินเทอร์เน็ต?", a: "มีเพียงไม่กี่อย่าง: การลงชื่อเข้าใช้และยืนยันอีเมลสำหรับทดลองใช้ Premium การดาวน์โหลดโมเดล และการตรวจหาอัปเดต พรอมต์ ไฟล์ และผลลัพธ์ของคุณจะไม่ถูกอัปโหลด เมื่อดาวน์โหลดโมเดลแล้ว AI ทำงานออฟไลน์ได้เต็มที่" },
      { q: 'อะไรฟรี อะไรต้องใช้พรีเมียม', a: 'Chat Apps ทั้งหมด การประมวลผลเอกสาร การดาวน์โหลดโมเดล และการอัปเดต ใช้ฟรี พรีเมียมปลดล็อก Agentic Apps ทั้งหมดทั้งปัจจุบันและอนาคต พร้อมเครื่องมือสร้าง Chat App และทดลองใช้ฟรีได้ 14 วัน' },
      { q: 'ใช้โมเดล AI อะไรบ้าง', a: 'โมเดลโอเพนซอร์สชั้นนำอย่าง Qwen และ Gemma รวมถึง Whisper สำหรับถอดเสียง ทำงานผ่านเอนจิน MLX ของ Apple ดาวน์โหลดและสลับโมเดลได้ในแอป' },
      { q: 'สร้างแอปเองได้ไหม', a: 'ได้ ใช้ Quick Bot เปลี่ยนไฟล์สูงสุด 3 ไฟล์เป็น Chat App ที่มีฐานความรู้ได้ในไม่กี่ขั้นตอน หรือใช้แคนวาสโหนดของ Playground เพื่อสร้างกิ่งก้าน AB test และแบบทดสอบ มีผู้ช่วยสร้างแอปในเครื่องคอยแนะนำตลอดทาง' },
      { q: 'องค์กรจะเริ่มใช้งานอย่างไร', a: 'ในแผนองค์กร ผู้ดูแลระบบจัดการผู้ใช้และกลุ่มใน My Org Admin และตรวจสอบทุกแอปก่อนเผยแพร่ ส่วนสมาชิกจะได้พื้นที่ My Org ในแบรนด์ขององค์กรภายใน Estha ติดต่อ {email}' },
    ],
  },
  final: { title: 'พร้อมรัน AI ในเครื่องแล้วหรือยัง', reqs: 'ใช้ได้กับ Mac ทุกเครื่องที่มี Apple Silicon · RAM ขั้นต่ำ 16GB' },
  footer: {
    tagline: 'ขุมพลัง AI ในเครื่องของคุณ — ทำงานบนอุปกรณ์ ขับเคลื่อนด้วย MLX เป็นส่วนตัวตั้งแต่การออกแบบ',
    product: 'ผลิตภัณฑ์', createApp: 'สร้างแอป', pricing: 'ราคา',
    orgs: "My Org", signIn: 'ลงชื่อเข้าใช้ My Org Admin',
    security: "ความปลอดภัย", changelog: "บันทึกการเปลี่ยนแปลง", docs: "เอกสาร", support: "ฝ่ายสนับสนุน",
    company: 'บริษัท', privacy: 'นโยบายความเป็นส่วนตัว', terms: 'ข้อกำหนดการให้บริการ',
    rights: '© 2026 Estha สงวนลิขสิทธิ์',
  },
  proof: { press: "ตามที่สื่อกล่าวถึง", voices: "เสียงจากทีมที่ใช้งาน" },
  contact: {
    title: "ส่งอีเมลถึงทีม Estha", copy: "คัดลอกที่อยู่อีเมล", copied: "คัดลอกแล้ว",
    gmail: "เขียนใน Gmail", mailApp: "เปิดในแอปเมล",
    subject: "สอบถามเกี่ยวกับ Estha for Mac",
  },
  share: {
    button: "แชร์", title: "แชร์ Estha",
    sub: "เลือกการ์ดแล้วโพสต์ หรือจะส่งแค่ลิงก์ก็ได้",
    style: "การ์ด", size: "ขนาด",
    templates: { hero: "Estha", agentic: "Agentic Apps", private: "ความเป็นส่วนตัว" },
    landscape: "แนวนอน", portrait: "แนวตั้ง",
    shareImage: "แชร์รูปภาพ…", download: "ดาวน์โหลดรูปภาพ", copyImage: "คัดลอกรูปภาพ", copied: "คัดลอกแล้ว",
    copyLink: "คัดลอกลิงก์", link: "ลิงก์", postTo: "โพสต์ไปที่",
    email: "อีเมล",
    text: "Estha รันโมเดล AI โอเพนซอร์สบน Mac ของคุณทั้งหมด เป็นส่วนตัว ใช้งานออฟไลน์ได้ และดาวน์โหลดฟรี",
    cardCta: "ดาวน์โหลดฟรี สำหรับ Mac ที่ใช้ Apple Silicon",
    close: "ปิด",
  },
  apps: {
    dataAnalyst: { name: 'นักวิเคราะห์ข้อมูล', description: 'อัปโหลดไฟล์ CSV/Excel แล้วถามคำถามด้วยภาษาธรรมชาติ สร้างแผนภูมิ การวิเคราะห์เชิงสถิติ และข้อมูลเชิงลึกโดยอัตโนมัติ — ประมวลผลทั้งหมดบน Mac ของคุณ', tags: ['CSV / Excel', 'แผนภูมิอัตโนมัติ', 'สอบถามด้วยภาษาธรรมชาติ', 'EN / 中文'] },
    pptMaker: { name: 'PPT Maker', description: 'อธิบายหัวข้อการนำเสนอของคุณแล้วรับสไลด์ PowerPoint ที่มีโครงสร้างระดับมืออาชีพ ไปป์ไลน์ AI หลายขั้นตอนจะสร้างโครงร่าง เนื้อหารายสไลด์ และไฟล์ .pptx ที่ขัดเกลาแล้ว', tags: ['ส่งออก .pptx', 'จัดเลย์เอาต์อัตโนมัติ', 'ไปป์ไลน์หลายขั้นตอน'] },
    pdfReader: { name: 'ตัวอ่าน PDF', description: 'เปิด PDF แล้วถามได้ทันที ทุกคำตอบอ้างอิงจากเอกสารพร้อมการอ้างอิงที่คลิกเพื่อกระโดดไปยังข้อความต้นทาง — ประมวลผลทั้งหมดบน Mac ของคุณ', tags: ['ถาม-ตอบ PDF', 'การอ้างอิงตรวจสอบได้', 'ถามจากข้อความที่เลือก', 'ประมวลผลในเครื่อง 100%'] },
    documentProcessing: { name: 'การประมวลผลเอกสาร', description: 'ผู้เชี่ยวชาญด้านเอกสารครบวงจรของคุณ ร่างบล็อกโพสต์ ข้อความโซเชียลมีเดีย ข้อกฎหมาย และเอกสารธุรกิจตั้งแต่เริ่มต้น แก้ไขและปรับปรุงไฟล์ที่มีอยู่ แปลข้ามภาษา และตรวจสอบคุณภาพเนื้อหา — ทั้งหมดเป็นส่วนตัวบน Mac ของคุณ', tags: ['ร่างและเขียน', 'แก้ไขและปรับปรุง', 'การแปล', 'ตรวจสอบและประเมิน'] },
    meetingIntelligence: { name: 'ระบบประชุมอัจฉริยะ', description: 'บันทึก ถอดเสียง และวิเคราะห์การประชุมด้วย AI สร้างรายงานการประชุม รายการสิ่งที่ต้องทำ และการตัดสินใจสำคัญโดยอัตโนมัติ — เป็นส่วนตัวอย่างสมบูรณ์ เสียงไม่เคยออกจากอุปกรณ์ของคุณ', tags: ['การถอดเสียง', 'รายงานการประชุม', 'รายการสิ่งที่ต้องทำ', 'เป็นส่วนตัว 100%'] },
    vibeCoding: { name: 'Vibe Coding: ต้นแบบ', description: 'สร้างตัวอย่างแบบอินเทอร์แอกทีฟด้วย AI อธิบายหน้าจอด้วยภาษาธรรมชาติ แล้วได้ต้นแบบที่คลิกได้ และปรับปรุงต่อได้เรื่อย ๆ ส่งออกเป็นไฟล์ .html เดี่ยวที่สมบูรณ์ในตัว — สร้างบน Mac ของคุณทั้งหมด', tags: ['ไฟล์ .html เดียว', 'ตัวอย่างอินเทอร์แอกทีฟ', 'คลิกเพื่อแก้ไข', 'ประมวลผลในเครื่อง 100%'] },
    translate: { name: "แปลภาษา", description: "แปลข้อความและเอกสาร Word, ข้อความ หรือ Markdown พร้อมอภิธานศัพท์ที่ใช้ร่วมกันเพื่อให้คำศัพท์สอดคล้องกัน ประมวลผลทั้งหมดบน Mac ของคุณ", tags: ["ข้อความและเอกสาร", ".docx / .txt / .md", "อภิธานศัพท์", "ในเครื่อง 100%"] },
  },
  screens: {
    chat: [
      { label: 'เลือกดูสโตร์', caption: 'เลือกดู ติดตั้ง ปักหมุด — ฟรีเสมอ' },
      { label: 'ติดตั้ง', caption: 'ติดตั้งแล้วฐานความรู้จะถูกสร้างในเครื่อง' },
      { label: 'ถาม', caption: 'คำตอบอ้างอิงจากคู่มือของแอป' },
    ],
    build: [
      { label: 'สร้างแอป', caption: 'Quick Bot หรือขั้นสูง — พร้อมแชตทั้งคู่' },
      { label: 'Quick Bot', caption: 'อัปโหลดฐานความรู้ เขียนพรอมป์ต เผยแพร่' },
      { label: 'Playground', caption: 'โหนด กิ่งก้าน และความรู้ — แบบภาพ' },
      { label: 'เผยแพร่แล้ว', caption: 'เผยแพร่แล้ว พร้อมแชต' },
    ],
    analyst: [
      { label: 'ถามคำถาม', caption: 'ถามข้อมูลของคุณด้วยภาษาธรรมชาติ' },
      { label: 'กำลังวิเคราะห์', caption: 'วิเคราะห์บน Mac ของคุณ' },
      { label: 'แผนภูมิและข้อมูลเชิงลึก', caption: 'คำตอบ แผนภูมิ และวิธีที่ได้มา' },
    ],
    ppt: [
      { label: 'ตั้งค่า', caption: 'หัวข้อ จำนวนสไลด์ ภาษา น้ำเสียง ธีม' },
      { label: 'ตรวจโครงร่าง', caption: 'แก้โครงร่างได้ก่อนเริ่มสร้าง' },
      { label: 'ดูตัวอย่างสไลด์', caption: 'ไฟล์ .pptx เสร็จสมบูรณ์ แก้ไขได้ — บน Mac ของคุณ' },
    ],
    pdf: [
      { label: 'เปิด PDF', caption: 'งานวิจัย รายงาน คู่มือ และเอกสารสแกน' },
      { label: 'กำลังอ่าน', caption: 'อ่านในเครื่องทีละหน้า' },
      { label: 'คำตอบพร้อมอ้างอิง', caption: 'ทุกคำตอบชี้ไปยังข้อความต้นฉบับที่ตรงจุด' },
    ],
    doc: [
      { label: 'เลือกข้อความ', caption: 'เลือกข้อความ แล้วบอกสิ่งที่ต้องการ' },
      { label: 'กำลังเขียนใหม่', caption: 'เขียนใหม่ในเอกสารได้ทันที' },
      { label: 'ยอมรับหรือปฏิเสธ', caption: 'เขียนใหม่ ขัดเกลา แปล — ยอมรับหรือปฏิเสธ' },
    ],
    meeting: [
      { label: 'บันทึกเสียง', caption: 'ถอดเสียงสดบน Mac เครื่องนี้' },
      { label: 'เลือกผลลัพธ์', caption: 'เลือกสิ่งที่ต้องการสร้าง' },
      { label: 'สรุป', caption: 'สรุปการตัดสินใจและสิ่งที่ต้องทำให้คุณ' },
      { label: 'สิ่งที่ต้องทำ', caption: 'ผู้รับผิดชอบและกำหนดส่ง พร้อมหลักฐาน' },
    ],
    vibe: [
      { label: 'อธิบาย', caption: 'อธิบายหน้าจอด้วยภาษาธรรมชาติ' },
      { label: 'กำลังสร้าง', caption: 'สร้างบน Mac เครื่องนี้ทั้งหมด' },
      { label: 'ต้นแบบ', caption: 'คลิกได้ มีเวอร์ชัน ไฟล์ .html เดียว' },
      { label: 'คลิกเพื่อแก้ไข', caption: 'เลือกส่วนไหนก็ได้ แล้วบอกว่าจะเปลี่ยนอะไร' },
    ],
    translate: [
      { label: "แปลข้อความ", caption: "คำสีม่วงมาจากอภิธานศัพท์ของคุณ" },
      { label: "แปลเอกสาร", caption: ".docx, .txt หรือ .md — ไฟล์ต้นฉบับไม่ถูกแก้ไข" },
      { label: "อภิธานศัพท์", caption: "อภิธานศัพท์ช่วยให้ทุกคำแปลสอดคล้องกัน" },
    ],
    private: [
      { label: 'บน Mac เครื่องนี้', caption: 'ออฟไลน์ทั้งหมด ข้อมูลไม่ออกจากเครื่องนี้' },
      { label: 'Mac Studio Cluster', caption: 'โมเดลที่ใหญ่กว่า — ภายในองค์กร' },
    ],
    org: [
      { label: 'พื้นที่แอปขององค์กร', caption: 'พื้นที่ในแบรนด์ของคุณ พร้อมแอปที่สร้างเพื่อทีม' },
      { label: 'แผนองค์กร', caption: 'สมาชิกเปิดได้เฉพาะแอปที่คุณอนุญาต' },
    ],
  },
};

export default th;
